import CloudComputing from './images/CloudComputing.jpg';
import IoT from './images/IoT.jpg';
import AI from './images/Deeplearning.jpg';
import JAM from './images/JAM Stack.jpg';
import BC from './images/BlockChain.jpg';

const coursesData = [
    {
        id:'CN-101',
        name:"CLOUD NATIVE COMPUTING",
        image:CloudComputing,
        desc:'This Course Is One Year Program',
    },
    {
        id:'IOT-101',
        name:"INTERNET OF THINGS",
        image:IoT,
        desc:'This Course Is One Year Program',
    },
    {
        id:'AI-101',
        name:"ARTIFICAL INTELLIGENCE",
        image:AI,
        desc:'This Course Is One Year Program',
    },
    {
        id:'BC-101',
        name:"BLOCK CHAIN",
        image:BC,
        desc:'This Course Is One Year Program',
    }

]

export default coursesData;